<script>
export default {
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }
  }
}
</script>

<template>
    <v-btn @click="handleClick" class="
    btn btn-outline-primary
    font-weight-bold
    btn-sm
    mr-2
    Mybtn1-primary
    Mybtn-size1
    ">
    <slot>Clickme</slot>
  </v-btn>
</template>
